import { render, staticRenderFns } from "./transitions.vue?vue&type=template&id=b2f56d00&"
import script from "./transitions.vue?vue&type=script&lang=js&"
export * from "./transitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports